// extracted by mini-css-extract-plugin
export var Logo = "Logo-module--Logo--52488";
export var logoMobile = "Logo-module--logoMobile--f9a38";
export var root = "Logo-module--root--460e0";